import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';

import ShareSomethingForm from '../components/SubmissionForm';
import FormFooter from '../components/FormFooter';
import HeaderBar from '../components/HeaderBar';
import withRouter from '../utils/withRouter';

const FormContainer = styled('form')(({ theme }) => ({
	'& .marginWithFooter': {
		marginBottom: theme.spacing(12)
	}
}));

// TODO - move to utility
const convertToBase64 = file => new Promise((resolve, reject) => {
	let reader = new FileReader();
	
	reader.onloadend = function() {
		let base64data = reader.result;
		resolve(base64data);
	}
	reader.onerror = function() {
		reject(new Error('File reading failed'));
	}
	reader.readAsDataURL(file); 
});

class ShareSomething extends Component {
	constructor(props, context) {
		super(props, context);
		
		// sentiment setup
		let sentiments = {
			uncertain: ['sad', 'scared', 'frustrated', 'angry', 'bullied', 'mad', 'ok'],
			negative: ['angry', 'scared', 'bullied', 'sad', 'frustrated', 'mad', 'ok']
		}
		let initialVals = [];

		this.category = "category" in props.match.params && props.match.params.category;
		if(this.category && this.category !== "positive") {
			this.triggerVal = 'something else...';
			this.sentimentValues = sentiments[this.category];
			this.sentimentMinValues = this.getMinifiedValues(this.sentimentValues);
			initialVals = this.sentimentMinValues;
		}

		let {locationKey, sourceType, embeddedOn} = props;
		this.state = {
			sentimentValues: initialVals,
			identify: false,
			concernOther: false,
			disableSubmit: false,
			formErrors: {},

			// Form values sent to API
			sentiment: null,
			identifyName: '',
			identifyEmail: '',
			identifyPhone: '',
			identifyEmailConf: '',
			concernOtherDescription: '',
			description: '',
			recaptchaToken: null,
			sourceType,
			embeddedOn,
			locationKey,
			attachments: []
		}
	}

	componentDidUpdate = prevProps => {
		let update = {};
		if (this.props.locationKey !== prevProps.locationKey) {
			update.locationKey = this.props.locationKey
		}
		if (this.props.embeddedOn !== prevProps.embeddedOn) {
			update.embeddedOn = this.props.embeddedOn
		}
		if (this.props.sourceType !== prevProps.sourceType) {
			update.sourceType = this.props.sourceType
		}

		if(Object.keys(update).length) {
			this.setState(update);
		}
	}

	getMinifiedValues = values => {
		let minValues = values.slice(0, 2);
		minValues.push(this.triggerVal);
		return minValues;
	}	

	onCloseTap = () => {
		const {messageSource, isTip} = this.props;

		if(isTip && messageSource) {
			messageSource.postMessage({
				type: "APP_CONTROL",
				action: "close"
			}, "*");
		} else {
			this.props.history.goBack();
		}
	}
	
	onIdentifyTap = event => {
		this.setState({identify: event.target.checked});
	}
	
	onConcernOtherTap = event => {
		this.setState({concernOther: event.target.checked});
	}
	
	onSelectFileTap = event => {
		if("files" in event.target && event.target.files.length) {
			const files = event.target.files;
			let results = [];

			// files are a files list & don't support map but is array-like
			for(let i = 0; i < files.length; i++) {
				results.push(convertToBase64(files[i]));
			}

			Promise.all(results)
				.then(b64Files => new Promise((resolve) => {
					let fileObjs = b64Files.map((data, idx) => ({
						name: files[idx].name,
						size: files[idx].size,
						lastModified: files[idx].lastModified,
						data
					}));

					let attachments = this.state.attachments.concat(fileObjs);
					this.setState({attachments});
					resolve('success');
				}))
				.catch(error => console.error(error));
		}
	}

	validateForm = () => {
		const { identify, identifyEmail } = this.state;
		let errors = {};

		// Email validation if identify is checked
		if (identify && identifyEmail) {
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			if (!emailRegex.test(identifyEmail)) {
				errors.identifyEmail = 'Please enter a valid email address';
			}
		}

		this.setState({ formErrors: errors });
		return Object.keys(errors).length === 0;
	}
	
	onSendTap = event => {
		event.preventDefault();
		
		if (!this.validateForm()) {
			return;
		}

		this.setState({disableSubmit: true});
		let category = this.category || "";
		let {recaptchaToken} = this.state;
		let body = this.getFieldValues();
		
		console.info(this.state);
		console.info(body);
		
		if(this.checkEmpty(body)) {
			this.setState({disableSubmit: false});
			return;
		}

		let options = {
			"headers": {
				"content-type": "application/json",
				"x-csrf-token": recaptchaToken
			},
			"method": "POST",
			"body": JSON.stringify(body)
		}
		let apiUrl = `/api/v1/share`;

		fetch(apiUrl, options)
			.then(response => {
				this.setState({disableSubmit: false});

				if(response.ok) {
					return response.json();
				} else {
					console.error(`${response.status} ${response.statusText}`);
					return {};
				}
			})
			.then(json => {
				console.info(json);
				this.props.history.replace(`/thanks/${category}`);
			})
			.catch(error => {
				this.setState({disableSubmit: false});
				console.error(`${error.name} ${error.message}`);
			});
	}

	checkEmpty = body => {
		for (let key in body) {
			if(['locationKey', 'messageSource', 'embeddedOn'].indexOf(key) === -1) {
				if((body[key] instanceof Array && body[key].length) || (!(body[key] instanceof Array) && body[key])) {
					return false
				}
			}
		}
		return true;
	}

	// Copy form values into "body", exclude items from state not meant to send
	getFieldValues = () => {
		let {sentimentValues, identify, concernOther, disableSubmit, recaptchaToken, formErrors, ...body} = this.state;

		// Override optional values if checkbox has been unchecked
		let identifyOverrides = {};
		let concernOtherOverrides = {};

		if(!identify) {
			identifyOverrides = {
				identifyName: '',
				identifyEmail: '', 
				identifyEmailConf: '', 
				identifyPhone: '', 
			};
		}

		if(!concernOther) {
			concernOtherOverrides = {
				concernOtherDescription: ''
			};
		}

		body = Object.assign({}, body, concernOtherOverrides, identifyOverrides);
		return body;
	}

	onSentimentChange = event => {
		let sentiment = event.target.value;

		// expand list
		if(this.state.sentimentValues.indexOf(sentiment) > 1) {
			// reset selection if triggerVal selected
			sentiment = sentiment !== this.triggerVal && sentiment || null;
			this.setState({
				sentimentValues: this.sentimentValues,
				sentiment
			})
		} else {
			this.setState({sentiment});
		}
	}

	onFieldChange = event => {
		let target = event.target,
			value = target.value;

		if (target.type === "checkbox") {
			value = target.checked;
		}

		// Clear form errors when user starts typing
		if (this.state.formErrors[target.name]) {
			this.setState({
				formErrors: {
					...this.state.formErrors,
					[target.name]: undefined
				}
			});
		}

		this.setState({[target.name]: value});
	}

	onRecaptchaChange = token => {
		console.log("Recaptcha token length: ", token.length);
		this.setState({recaptchaToken: token});
	}

	render() {
		let {isTip, recaptchaRef} = this.props;
		let title, placeholder;
		let descriptionLabel = "What's happening?";
		let notGood = (this.category && this.category !== 'positive');
		// need null so attachment count is blank when 0
		let attachedCount = this.state.attachments.length || null;

		if(isTip) {
			title = "Something Suspicious?";
			placeholder = "Please enter as much detail about your concern as possible."
		} else {
			title = 'What\'s ' + ((this.category === 'positive' && 'GOOD') || 'WRONG');
			placeholder = "Please enter as much detail as possible."
		}

		return (
			<FormContainer 
				noValidate
				autoComplete="off"
				onSubmit={this.onSendTap}
			>
				<HeaderBar 
					category={isTip ? "tip" : this.category} 
					title={title}
					closeHandler={this.onCloseTap}
					recaptchaRef={recaptchaRef}
					recaptchaHandler={this.onRecaptchaChange}
				/>
				<div className="marginWithFooter">
					<ShareSomethingForm 
						category={this.category}
						descriptionLabel={descriptionLabel}
						placeholder={placeholder}
						sentimentProps={{
							values: this.state.sentimentValues,
							selection: this.state.sentiment,
							changeHandler: this.onSentimentChange,
							visible: notGood,
						}} 
						identifyHandler={this.onIdentifyTap} 
						concernOtherHandler={this.onConcernOtherTap}
						fieldChangeHandler={this.onFieldChange}
						showConcernOther={notGood}
						formErrors={this.state.formErrors}

						description={this.state.description}
						identify={this.state.identify}
						identifyName={this.state.identifyName}
						identifyEmail={this.state.identifyEmail}
						identifyEmailConf={this.state.identifyEmailConf}
						identifyPhone={this.state.identifyPhone}
						concernOther={this.state.concernOther} 
						concernOtherDescription={this.state.concernOtherDescription} 
					/>
				</div>
				<FormFooter
					category={isTip ? "tip" : this.category}
					attachedCount={attachedCount}
					disableSubmit={this.state.disableSubmit}
					selectFileHandler={this.onSelectFileTap} />
			</FormContainer>
		);
	}
}

ShareSomething.propTypes = {
	isTip: PropTypes.bool,
	sourceType: PropTypes.string,
	match: PropTypes.object.isRequired,
	messageSource: PropTypes.object,
	embeddedOn: PropTypes.string,
	locationKey: PropTypes.string,
	recaptchaRef: PropTypes.object,
	history: PropTypes.object.isRequired
};

export default withRouter(ShareSomething);